<template>
  <div class="margin-general">
    <div class="what-is-content">
      <div class="what-is-left">
        <!-- Usa v-html para renderizar el título con HTML -->
        <h2 v-html="titleWithHtml"></h2>
      </div>
      <div class="what-is-rigth">
        <div v-for="(paragraph, index) in filteredContent" :key="index">
          <p>
            <template v-for="(part, partIndex) in paragraph" :key="partIndex">
              <strong v-if="part.strong">{{ part.text }}</strong>
              <template v-else-if="!part.locale || part.locale === locale">
                <span>{{ part.text }}</span>
              </template>
            </template>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  content: {
    type: Array,
    required: true
  }
});

const { locale } = useI18n();

// Reemplazar el marcador [br] por la etiqueta <br> y verificar que sea procesado correctamente
const titleWithHtml = computed(() => {
  return props.title.replace(/\[br\]/g, '<br>');
});

const filteredContent = computed(() => {
  return props.content.map(paragraph => {
    return paragraph.filter(part => !part.locale || part.locale === locale.value);
  }).filter(paragraph => paragraph.length > 0);
});
</script>
